namespace RioERP.Orders {
    export interface OrdersforFranchiseeForm {
        OrderDate: Serenity.DateEditor;
        OrderNumber: Serenity.StringEditor;
        SourceOrderNumber: Serenity.StringEditor;
        ESourceType: Serenity.EnumEditor;
        EOrderStatus: Serenity.EnumEditor;
        SourceName: Serenity.StringEditor;
        Mode: Serenity.LookupEditor;
        Level: Serenity.LookupEditor;
        CustomerName1: Serenity.StringEditor;
        CustomerEmail1: Serenity.EmailEditor;
        CustomerEmail2: Serenity.EmailEditor;
        CustomerMobile11: Serenity.StringEditor;
        CustomerMobile21: Serenity.StringEditor;
        InvoiceCompanyId: Serenity.LookupEditor;
        EInvoiceTo: Serenity.EnumEditor;
        BillingAddress1: Serenity.StringEditor;
        BillingAddress2: Serenity.StringEditor;
        BillingCity: Serenity.StringEditor;
        BillingStateId: Serenity.LookupEditor;
        BillingPincode: Serenity.IntegerEditor;
        OrderProducts: OrderProductsEditor;
        OrderInstallments: OrderInstallmentEditor;
        GrossAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        Note: Serenity.TextAreaEditor;
        EPaymentType: Serenity.EnumEditor;
        EPaymentStatus: Serenity.EnumEditor;
    }

    export class OrdersforFranchiseeForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrdersforFranchisee';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrdersforFranchiseeForm.init)  {
                OrdersforFranchiseeForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = s.LookupEditor;
                var w4 = s.EmailEditor;
                var w5 = s.IntegerEditor;
                var w6 = OrderProductsEditor;
                var w7 = OrderInstallmentEditor;
                var w8 = s.DecimalEditor;
                var w9 = s.TextAreaEditor;

                Q.initFormType(OrdersforFranchiseeForm, [
                    'OrderDate', w0,
                    'OrderNumber', w1,
                    'SourceOrderNumber', w1,
                    'ESourceType', w2,
                    'EOrderStatus', w2,
                    'SourceName', w1,
                    'Mode', w3,
                    'Level', w3,
                    'CustomerName1', w1,
                    'CustomerEmail1', w4,
                    'CustomerEmail2', w4,
                    'CustomerMobile11', w1,
                    'CustomerMobile21', w1,
                    'InvoiceCompanyId', w3,
                    'EInvoiceTo', w2,
                    'BillingAddress1', w1,
                    'BillingAddress2', w1,
                    'BillingCity', w1,
                    'BillingStateId', w3,
                    'BillingPincode', w5,
                    'OrderProducts', w6,
                    'OrderInstallments', w7,
                    'GrossAmount', w8,
                    'NetAmount', w8,
                    'TaxableAmount', w8,
                    'Note', w9,
                    'EPaymentType', w2,
                    'EPaymentStatus', w2
                ]);
            }
        }
    }
}
